import { Button } from "components/DesignSystem/Button/Button";
import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import { EditPencil } from "components/icons/EditPencil";
import { useFormikContext } from "formik";
import { useState } from "react";
import { MultiValue, SingleValue } from "react-select";
import { EntityDataAttribute } from "types/Models/entity";

type EntityFormationTypeFieldProps = {
  field: EntityDataAttribute;
  canEdit: boolean;
  onChange?: ({
    name,
    value,
  }: {
    name: string;
    value: EntityDataAttribute["value"];
  }) => void;
};

export const EntityFormationTypeField = ({
  field,
  canEdit,
  onChange,
}: EntityFormationTypeFieldProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const { values: formikValues, setFieldValue } = useFormikContext();
  const { name, options } = field;
  //   @ts-ignore
  const value = (formikValues[name] as string) ?? "";

  const startEditing = () => setIsEditing(true);
  const stopEditing = () => setIsEditing(false);

  const handleChange = (
    option: SingleValue<OptionData> | MultiValue<OptionData>
  ) => {
    if (!option || option instanceof Array) return;
    setFieldValue(name, option.label);
    const isUnchanged = option.label === field.value;
    onChange?.({ name, value: isUnchanged ? field.value : option.value });
    stopEditing();
  };

  const selectedOption =
    options?.find((option) => option.label === value) || null;

  if (isEditing) {
    return (
      <div className="t-min-w-[220px]">
        <Combobox
          size="small"
          options={options || []}
          name={name}
          value={selectedOption}
          onChange={handleChange}
          menuPortalTarget={document.body}
          autoFocus
          openMenuOnFocus
          onBlur={stopEditing}
          fullWidth
        />
      </div>
    );
  }

  return (
    <div className="t-flex t-gap-1 t-items-center">
      {value}
      {canEdit && (
        <Button
          customType="ghost"
          size="xsmall"
          onClick={startEditing}
          type="button"
        >
          <EditPencil />
        </Button>
      )}
    </div>
  );
};
